var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"demo-option":"demoDemographics"}},[(_vm.isMobile)?[_c('b-container',{attrs:{"fluid":""}},[_c('m-demo-select',{attrs:{"propDemoType":1}})],1)]:[_c('div',{staticClass:"mt-4"},[_c('m-demo-all-check')],1),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('m-demo-select-p-c',{attrs:{"propDemoType":1}})],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83872d40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/DemoDemographics.vue
// module id = null
// module chunks = 